
import axios from 'axios';

const sendFileMessage = async (token, contactId, file) => {

    ///First upload the file to the server

    const formData = new FormData();
	formData.append('file', file ,file.name);

    console.log('FORMDATA', formData);
    console.log('sendFileMessage input file object', file)
    try {
        const response = await axios.post(process.env.REACT_APP_BACKEND_HOST+'/api/v1/upload',formData);
        console.log('Response uploading file',response.data);
    
    } catch (err) {
        console.error(err);
        throw new Error(err.message); 
    }


  /// Send the file to twilio via backend server

  var data = {
    "token": token,
    "contactId": contactId,
    "file": file.name
  };
  
  const headers = { 
      'Content-Type': 'application/json'
  };

  console.log(data);
  try {
      let response = await axios.post(process.env.REACT_APP_BACKEND_HOST+'/api/v1/message/send-file-message', data, { headers })
      console.log('Response sending file',response);
      if(response.data.status !== 200)
          throw new Error(response.data.message); 
  }catch(err) {
      console.log(err);
      throw new Error(err.message); 
  }
    
};

export default sendFileMessage